<template>
  <div class="passStrengthBars" :class="classReturn">
    <div class="passBar" />

    <div class="passBar" />

    <div class="passBar" />

    <div class="passBar" />

    <div class="passBar" />
  </div>
</template>

<script>
import owasp from './owasp-password-strength'

owasp.config({
  minLength: 8,
  allowPassphrases: false,

})

export default {
  props: {
    password: {
      type: String,
      default: ''
    }
  },
  computed: {
    gaugePass() {
      return owasp.test(this.password)
    },
    classReturn(){
      const classes = ['is-weaker', 'is-weak', 'is-medium', 'is-strong', 'is-stronger']

      if (!this.password) {
return
}
      if (this.gaugePass.requiredTestErrors.length > 0) {
return classes[0]
}

      const passedCount = this.gaugePass.passedTests.length

      if (passedCount -3 > classes.length) {
return classes[classes.length-1]
}

      return classes[passedCount - 3]
    }
  }
}
</script>

<style lang="scss" scoped>
//@import '../../styles/app/shared.scss';
@import '~assets/css/shared.scss';

.passStrengthBars {
  display: flex;
  flex: 1 1 100%;
  padding-top: 2px;
}

.passStrengthBars.is-weaker .passBar:first-child {
  background-color: $danger;
}

.passStrengthBars.is-weak .passBar:nth-child(-n + 2) {
  background-color: $orange;
}

.passStrengthBars.is-medium .passBar:nth-child(-n + 3) {
  background-color: $warning;
}

.passStrengthBars.is-strong .passBar:nth-child(-n + 4) {
  background-color: $success;
}

.passStrengthBars.is-stronger .passBar {
  background-color: $success;
}

.passBar {
  background-color: transparent;
  border-radius: 100px;
  flex: 1 1;
  height: 4px;
}

.passBar + .passBar {
  margin-left: 2px;
}
</style>
